import { ChangeDetectionStrategy, Component, OnDestroy, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { CallState } from '@lcs/shared/api';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { AppState } from 'src/app/app.reducer';
import { getCurrentUser } from 'src/app/authentication/state/authentication.selector';
import { Detail } from 'src/app/common-components/detail/detail';
import { FormsBase } from 'src/app/common-components/forms-base/forms-base';
import { getUserPreferences } from 'src/app/store/user-preferences/user-preferences.selectors';
import { GetUserDetail_user } from '../../user-details/queries/generated/GetUserDetail';
import { UserPreferenceDetailSaveEvent } from '../models/user-preference-detail-form-submit-event';
import { UserPreferenceDetailFormService } from '../services/user-preference-detail-form.service';
import { loadCurrentUserId, saveUserPreferenceDetail } from '../state/user-preference-detail.actions';
import * as UserPreferenceDetailSelectors from './../state/user-preference-detail.selectors';

@Component({
    selector: 'ndt-user-preference-detail',
    host: { class: 'entity-detail' },
    providers: [UserPreferenceDetailFormService, { provide: FormsBase, useExisting: UserPreferenceDetailFormService }],
    templateUrl: './user-preference-detail.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class UserPreferenceDetailComponent extends Detail<UserPreferenceDetailFormService> implements OnDestroy {
   callState$: Observable<CallState>;

   user$: Observable<GetUserDetail_user | null>;

   constructor(
      public store: Store<AppState>,
      private router: Router,
      protected formService: UserPreferenceDetailFormService
   ) {
      super(store, formService);
      this.callState$ = store.pipe(select(UserPreferenceDetailSelectors.getCallState));
      this.user$ = store.pipe(select(UserPreferenceDetailSelectors.getUser));
      store.pipe(select(getCurrentUser)).subscribe((user) => {
         if (user) {
            this.store.dispatch(loadCurrentUserId({ userId: user?.userId }));
            this.loadPreferences();
         }
      });
   }

   loadPreferences() {
      this.store
         .pipe(
            select(getUserPreferences),
            filter((preferences) => preferences != null)
         )
         .subscribe((userPreferences) => {
            this.formService.updateUserPreferences(userPreferences!);
         });
   }

   onSavePreferences(userPreferences: UserPreferenceDetailSaveEvent): void {
      this.store.dispatch(saveUserPreferenceDetail(userPreferences));
   }

   onCancel() {
      this.loadPreferences();
   }
}
